import type { ICandidate } from "@bbj-types/candidate";
import { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { useMemo } from "react";

export const isSmsEligibleCandidate = (candidate: Pick<ICandidate, "optInPhone" | "phone">) => {
  return Boolean(candidate.optInPhone && candidate.phone);
};

export const isEmailEligibleCandidate = (candidate: Pick<ICandidate, "optInEmail" | "mail" | "isEmailValid">) => {
  return Boolean(candidate.optInEmail && candidate.mail && candidate.isEmailValid);
};

export const getSmsEligibleCandidates = <T extends Pick<ICandidate, "optInPhone" | "phone">>(
  candidates: readonly T[]
): T[] => {
  return candidates.filter(isSmsEligibleCandidate);
};

export const getEmailEligibleCandidates = <T extends Pick<ICandidate, "optInEmail" | "mail" | "isEmailValid">>(
  candidates: readonly T[]
): T[] => {
  return candidates.filter(isEmailEligibleCandidate);
};

export const useEligibleCandidates = <
  T extends Pick<ICandidate, "optInEmail" | "optInPhone" | "mail" | "phone" | "isEmailValid">,
>(
  type: CommunicationTemplateType,
  candidates: readonly T[]
): T[] => {
  return useMemo(() => {
    switch (type) {
      case CommunicationTemplateType.EMAIL:
        return getEmailEligibleCandidates(candidates);
      case CommunicationTemplateType.SMS:
        return getSmsEligibleCandidates(candidates);
      default:
        return [];
    }
  }, [type, candidates]);
};
